import { useTranslation } from "react-i18next";
import ButtonComponent from "../../../cubeComponent/form/ButtonComponent";
import css from "./index.module.css";

function AttachFiles({ onCancelClick, onAcceptClick }) {
  const { t } = useTranslation();
  return (
    <div className={css.fileManagerModalOverlayWrapper}>
      <div className={css.fileManagerModalWrapper}>
        <div className={css.headingWrapper}>
          <div className={css.heading}>{t("Attach Files")}</div>
          <span className={css.crossIcon} onClick={onCancelClick}>
            &#10005;
          </span>
        </div>
        <div>
          The issue(s) that you have selected are associated to the file(s). You can only transmit issues if the
          associated files are also being transmitted as a part of the same transmittal.
        </div>
        <div className={css.footerButtons}>
          <ButtonComponent buttonType="gradientButton" onClick={onAcceptClick} cssClass="e-info">
            {t("Attach Files")}
          </ButtonComponent>
          <ButtonComponent onClick={onCancelClick} cssClass={`e-flat ${css.buttonLight}`}>
            Cancel
          </ButtonComponent>
        </div>
      </div>
    </div>
  );
}

export default AttachFiles;
